import TripItemRailGroupModule from './trip-item-rail-group/trip-item-rail-group-module';
import TripItemService from './trip-item-service';

const MODULE_NAME = 'app.trip.item-group';
const module = angular.module(MODULE_NAME, [
        TripItemRailGroupModule,
    ])
    .service('tripItemService', TripItemService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-group/trip-item-group-module.js